module.exports = __webpack_public_path__ + "img/anquan1-3.99214f69.jpg";